import { useMutation } from "@tanstack/react-query";

import { apiClient } from "../../api/apiClient";
import { queryCosmosApiV1CosmosQueryPost } from "../../api/generated/sdk.gen";
import { CosmosQueryRequestSchema } from "../../api/generated/types.gen";

/**
 * Query Cosmos database for information related to a case
 * @returns Mutation for querying Cosmos
 */
export const useCosmosQuery = () => {
  return useMutation({
    mutationFn: async (data: CosmosQueryRequestSchema) => {
      const response = await queryCosmosApiV1CosmosQueryPost({
        client: apiClient,
        body: data,
      });

      // Check for errors in the response
      if ("error" in response && response.error) {
        throw new Error(
          `Failed to query Cosmos: ${response.error.detail || JSON.stringify(response.error)}`
        );
      }

      return response.data;
    },
  });
};
